import React, { useEffect } from "react";
import "../../styles/App.css";

function CompanyInfoModal({ isOpen, onClose, company = {}, onSwitch }) {
  useEffect(() => {
    if (isOpen) {
      const scrollY = window.scrollY;
      document.body.classList.add("modal-open");
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
      document.body.style.height = "100%";
      document.documentElement.style.overflow = "hidden";

      const preventScroll = (e) => {
        if (
          !e.target.closest(".switch-company-modal") &&
          !e.target.closest(".company-info-modal")
        ) {
          e.preventDefault();
        }
      };

      document.addEventListener("touchmove", preventScroll, { passive: false });
      document.addEventListener("wheel", preventScroll, { passive: false });

      return () => {
        document.removeEventListener("touchmove", preventScroll);
        document.removeEventListener("wheel", preventScroll);
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";
        document.body.style.height = "";
        document.documentElement.style.overflow = "";

        window.scrollTo(0, scrollY);
      };
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const renderValue = (val) => {
    if (val === null || typeof val === "undefined") return "-";
    if (
      typeof val === "string" ||
      typeof val === "number" ||
      typeof val === "boolean"
    )
      return String(val);
    try {
      const json = JSON.stringify(val, null, 2);
      return json.length > 200 ? json.slice(0, 200) + "..." : json;
    } catch (e) {
      return String(val);
    }
  };

  const rawKeys = company ? Object.keys(company) : [];
  const blacklistPatterns = [
    "request",
    "limit",
    "count",
    "created",
    "updated",
    "updates",
    "logo",
  ];

  const keys = rawKeys.filter((k) => {
    const lk = String(k).toLowerCase();
    if (lk === "name" || lk === "id" || lk === "api_key") return true;
    for (const p of blacklistPatterns) {
      if (lk.includes(p)) return false;
    }
    return true;
  });

  return (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="switch-company-modal company-info-modal">
        <div className="modal-header">
          <h3>Company details</h3>
          <button
            className="modal-close-btn"
            onClick={onClose}
            aria-label="Close modal"
          >
            ✕
          </button>
        </div>

        <div className="modal-body">
          <div style={{ display: "flex", gap: 12, alignItems: "center" }}>
            <div
              style={{
                width: 56,
                height: 56,
                borderRadius: 999,
                background: "linear-gradient(135deg,#e6eefc,#eef7ff)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: 20,
                color: "#0f172a",
                border: "2px solid rgba(59,130,246,0.12)",
              }}
            >
              {company.name ? company.name.charAt(0).toUpperCase() : "C"}
            </div>

            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  fontWeight: 800,
                  fontSize: 18,
                  color: "var(--wv-text)",
                }}
              >
                {company.name || "Unnamed Company"}
              </div>
              {company.description && (
                <div style={{ color: "var(--wv-text-2)", marginTop: 6 }}>
                  {company.description}
                </div>
              )}
            </div>
          </div>

          <div style={{ marginTop: 18 }}>
            <div
              style={{ display: "grid", gridTemplateColumns: "1fr", gap: 8 }}
            >
              {keys.length === 0 && (
                <div style={{ color: "var(--wv-text-2)" }}>
                  No additional info
                </div>
              )}
              {keys.map((k) => (
                <div
                  key={k}
                  style={{ display: "flex", gap: 12, alignItems: "flex-start" }}
                >
                  <div
                    style={{
                      minWidth: 140,
                      color: "var(--wv-text-2)",
                      fontSize: 13,
                      fontWeight: 700,
                    }}
                  >
                    {k}
                  </div>
                  <div
                    style={{
                      color: "var(--wv-text-2)",
                      fontSize: 13,
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                    }}
                  >
                    {renderValue(company[k])}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose}>
            Close
          </button>
          <button
            className="btn btn-primary"
            onClick={() => {
              if (typeof onSwitch === "function") onSwitch();
            }}
          >
            Switch Company
          </button>
        </div>
      </div>
    </div>
  );
}

export default CompanyInfoModal;
